import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { Layout, Menu } from 'antd';

const { Header, Content, Footer } = Layout;

class CustomLayout extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { location } = this.props;
    console.log(location.pathname)
    return (
      <Layout className="layout">
        <Header>
          <div className="logo" />
          <Menu
            theme="dark"
            mode="horizontal"
            defaultSelectedKeys={[location.pathname]}
            style={{ lineHeight: '64px' }}
          >
            <Menu.Item key="/"><NavLink exact={true} to='/'>Home</NavLink></Menu.Item>
            <Menu.Item key="/about/"><NavLink to='/about/'>About</NavLink></Menu.Item>
          </Menu>
        </Header>
        <Content style={{ padding: '0 0px' }}>
          <div style={{ padding: '40px 180px', minHeight: 280 }}>
            {this.props.children}
          </div>
        </Content>
        <Footer style={{ textAlign: 'center' }}> ©2019 Created by <a href='https://vandyliu.github.io'>Vandy Liu</a></Footer>
      </Layout >
    );
  }
}

export default withRouter(CustomLayout);
